export const changeOfCustomerContactDetailsSchema = {
  title: 'Contact Details Change',
  type: 'object',
  properties: {
    mpan_core: {
      type: 'string',
      title: 'MPAN Core',
    },
    customers: {
      type: 'array',
      title: 'Customers',
      minItems: 1,
      items: {
        type: 'object',
        title: 'Customer',
        properties: {
          customer_name: {
            type: 'string',
            title: 'Customer Name',
          },
          additional_information: {
            type: 'string',
            title: 'Additional Information',
          },
          customer_password: {
            type: 'string',
            title: 'Customer Password',
          },
          customer_password_efd: {
            type: 'string',
            format: 'date',
            title: 'Customer Password EFD',
          },
          special_access: {
            type: 'string',
            title: 'Special Access',
          },
          max_power_req: {
            type: 'number',
            title: 'Max Power Req',
          },
          delete_address_data: {
            type: 'boolean',
            title: 'Delete Address Data',
            default: false,
          },
          mailing_address_1: { type: 'string', title: 'Mailing Address 1' },
          mailing_address_2: { type: 'string', title: 'Mailing Address 2' },
          mailing_address_3: { type: 'string', title: 'Mailing Address 3' },
          mailing_address_4: { type: 'string', title: 'Mailing Address 4' },
          mailing_address_5: { type: 'string', title: 'Mailing Address 5' },
          mailing_address_6: { type: 'string', title: 'Mailing Address 6' },
          mailing_address_7: { type: 'string', title: 'Mailing Address 7' },
          mailing_address_8: { type: 'string', title: 'Mailing Address 8' },
          mailing_address_9: { type: 'string', title: 'Mailing Address 9' },
          mailing_address_postcode: {
            type: 'string',
            title: 'Mailing Address Postcode',
          },
          contacts: {
            type: 'array',
            title: 'Contacts',
            minItems: 1,
            items: {
              type: 'object',
              title: 'Contact',
              properties: {
                contact_name: {
                  type: 'string',
                  title: 'Contact Name',
                },
                preferred_contact_method: {
                  type: 'string',
                  title: 'Preferred Contact Method',
                  enum: ['E', 'H', 'L', 'W', 'T'],
                  enumNames: ['E - Email', 'H - Home visit', 'L - Letter', 'W - Web', 'T - Telephone'],
                },
                telephones: {
                  type: 'array',
                  title: 'Telephone Numbers',
                  minItems: 1,
                  items: {
                    type: 'object',
                    title: 'Telephone',
                    properties: {
                      telephone_number: {
                        type: 'string',
                        title: 'Telephone Number',
                      },
                      fax_number: {
                        type: 'string',
                        title: 'Fax Number',
                      },
                    },
                    required: ['telephone_number'],
                  },
                },
                emails: {
                  type: 'array',
                  title: 'Emails',
                  minItems: 1,
                  items: {
                    type: 'object',
                    title: 'Email',
                    properties: {
                      email_address: {
                        type: 'string',
                        title: 'Email Address',
                      },
                    },
                    required: ['email_address'],
                  },
                },
              },
              required: ['contact_name', 'telephones', 'emails'],
            },
          },
        },
        required: ['customer_name', 'mailing_address_postcode', 'contacts'],
      },
    },
  },
  required: ['mpan_core', 'customers'],
};

export const changeOfCustomerContactDetailsUISchema = {
  mpan_core: {
    'ui:placeholder': 'Select MPAN',
  },
  customers: {
    'ui:options': {
      orderable: false,
    },
    items: {
      customer_name: {
        'ui:placeholder': 'Enter customer name',
      },
      additional_information: {
        'ui:placeholder': 'Enter additional information',
      },
      customer_password: {
        'ui:placeholder': 'Enter customer password',
      },
      customer_password_efd: {
        'ui:widget': 'date',
      },
      special_access: {
        'ui:placeholder': 'Enter special access details',
      },
      max_power_req: {
        'ui:placeholder': 'Enter max power requirement',
      },
      delete_address_data: {
        'ui:widget': 'checkbox',
      },
      mailing_address_1: { 'ui:placeholder': 'Address line 1' },
      mailing_address_2: { 'ui:placeholder': 'Address line 2' },
      mailing_address_3: { 'ui:placeholder': 'Address line 3' },
      mailing_address_4: { 'ui:placeholder': 'Address line 4' },
      mailing_address_5: { 'ui:placeholder': 'Address line 5' },
      mailing_address_6: { 'ui:placeholder': 'Address line 6' },
      mailing_address_7: { 'ui:placeholder': 'Address line 7' },
      mailing_address_8: { 'ui:placeholder': 'Address line 8' },
      mailing_address_9: { 'ui:placeholder': 'Address line 9' },
      mailing_address_postcode: {
        'ui:placeholder': 'Enter postcode',
      },
      contacts: {
        'ui:options': {
          orderable: false,
        },
        items: {
          contact_name: {
            'ui:placeholder': 'Enter contact name',
          },
          preferred_contact_method: {
            'ui:placeholder': 'Select preferred contact method',
          },
          telephones: {
            'ui:options': {
              orderable: false,
            },
            items: {
              telephone_number: {
                'ui:placeholder': 'Enter telephone number',
              },
              fax_number: {
                'ui:placeholder': 'Enter fax number',
              },
            },
          },
          emails: {
            'ui:options': {
              orderable: false,
            },
            items: {
              email_address: {
                'ui:placeholder': 'Enter email address',
              },
            },
          },
        },
      },
      'ui:order': [
        'customer_name',
        'additional_information',
        'customer_password',
        'customer_password_efd',
        'special_access',
        'max_power_req',
        'delete_address_data',
        'mailing_address_1',
        'mailing_address_2',
        'mailing_address_3',
        'mailing_address_4',
        'mailing_address_5',
        'mailing_address_6',
        'mailing_address_7',
        'mailing_address_8',
        'mailing_address_9',
        'mailing_address_postcode',
        'contacts',
      ],
    },
  },
  'ui:order': ['mpan_core', 'customers'],
};
